import { bindActionCreators } from 'redux';
import State from '@wfp-root-app/store/state';
import { connect } from 'react-redux';

import AsyncTasksPage from './AsyncTasksPage';
import { ManagerPermission } from '../../permission-profiles/permission';
import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import { hasFeatureAccess } from '../../login/auth';
import AsyncTasksListView from '../AsyncTasksListView';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        authorizeTask: bindActionCreators(AsyncActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.UPLOAD_REMOVE_ENTITLEMENTS)),
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
    };
}

function mapStateToProps(state: State, _ownProps) {
    const canImport = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementPark);
    const canAuthorizeTask = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementVerify);
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);
    return {
        canPark: canImport && state?.auth?.manager?.agency !== 'ALL',
        canPost: canAuthorizeTask,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.UPLOAD_REMOVE_ENTITLEMENTS],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BB Remove Assistance Template.xlsx',
        name: 'Upload Remove Assistance File',
        type: AsyncTasksTypes.UPLOAD_REMOVE_ENTITLEMENTS,
        uploadDescription: 'Upload the Remove Assistance XLSX.GPG file by clicking the button below.',
        exampleLinkTitle: 'See example import file',
        listView: AsyncTasksListView,
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
        mapping: state.appConfig.removeEntitlementsImportMapping,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage);
